module.exports = __webpack_public_path__ + "4dd3865b592a94038a2b6878bb29e9de.pdf";